<template>
  <template v-if="appName === 'GDL'">
    <v-card v-if="!tipoAplicacionSeleccionado" class="mx-auto my-8" max-width="620" elevation="2">
      <v-card-title class="text-center text-h5 py-4">
        {{ $t('$vuetify.comoAplicar') }}
      </v-card-title>
      <v-card-text>
        <p class="text-center mb-6">{{ $t('$vuetify.selopcionsol') }}</p>
        <v-row justify="center" dense>
          <v-col cols="12" sm="auto" class="text-center pa-2">
            <v-btn-primary
              class="mt-2"
              size="large"
              @click="seleccionarTipo('pasantes')"
              prepend-icon="fa-solid fa-graduation-cap"
              color="secondary"
              block
            >
              {{ $t('$vuetify.aplicarPasantia') }}
            </v-btn-primary>
          </v-col>
          <v-col cols="12" sm="auto" class="text-center pa-2">
            <v-btn-primary
              class="mt-2"
              size="large"
              @click="seleccionarTipo('vacantes')"
              prepend-icon="fa-solid fa-user-tie"
              block
            >
              {{ $t('$vuetify.aplicarVacante') }}
            </v-btn-primary>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <div v-if="tipoAplicacionSeleccionado" class="text-center mt-6">
      <v-btn variant="outlined" @click="resetSeleccion" class="mr-4">
        {{ $t('$vuetify.volverTipo') }}
      </v-btn>
    </div>
    <div v-if="tipoAplicacionSeleccionado === 'vacantes'">
      <FormSolCandidatos />
    </div>
    <div v-else-if="tipoAplicacionSeleccionado === 'pasantes'">
      <FormSolPasante />
    </div>
  </template>
  <template v-else>
    <FormSolCandidatos />
  </template>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { useAppStore } from '@/store/app';
import { useLocale } from 'vuetify';
import { useRoute } from 'vue-router';

const { current } = useLocale();
const { getDataForm } = useAppStore();
const route = useRoute();

const store = useAppStore();
const appName = import.meta.env.VITE_APP_NAME;

type TipoAplicacion = 'pasantes' | 'vacantes';

const tipoAplicacionSeleccionado = ref<TipoAplicacion | null>(null);

const seleccionarTipo = (tipo: TipoAplicacion): void => {
  tipoAplicacionSeleccionado.value = tipo;
  // eslint-disable-next-line no-console
  // console.log(`Tipo seleccionado: ${tipo}`, appName);

  store.$reset(); // Resetear el formulario en cada selección
  getDataForm(current.value, route); // Cargar los datos del formulario
};

const resetSeleccion = (): void => {
  tipoAplicacionSeleccionado.value = null;
};
</script>
